import {
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { DatasetDropdownProps } from "./DatasetDropdown-interface";
import "./DatasetDropdown.scss";
import { useCountryList } from "../../../services/okta";

const DatasetDropdown = ({ value, onChange, disabled }: DatasetDropdownProps) => {
  const {
    data: dataCountries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useCountryList();

  const countries = useMemo(() => {
    if (!dataCountries) return [];

    if (Array.isArray(dataCountries)) {
      return dataCountries.map((c: any) => ({
        name: c.name ?? c.country ?? "",
        admin: c.admin ?? null,
        countryCode: c.countryCode ?? null,
      }));
    }

    if (typeof dataCountries === "object") {
      return Object.entries(dataCountries).map(
        ([key, details]: [string, any]) => ({
          name: details.name ?? details.country ?? key,
          admin: details.admin ?? null,
          countryCode: details.countryCode ?? null,
        })
      );
    }

    return [];
  }, [dataCountries]);


  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    if ((value === undefined || value === "") && countries.length > 0) {
      const defaultVal = countries[0].name;
      setInternalValue(defaultVal);
      onChange?.({ target: { value: defaultVal } } as any);
    } else {
      setInternalValue(value);
    }
  }, [value, countries, onChange]);

  const handleChange = (event: SelectChangeEvent) => {
    setInternalValue(event.target.value);
    onChange?.(event);
  };

  if (isLoadingCountries) {
    return <CircularProgress size={24} />;
  }

  if (isErrorCountries) {
    return <div>Error loading countries</div>;
  }

  if (countries.length === 0) {
    return <div>No available countries</div>;
  }
  const displayCountries = (() => {
    if (!internalValue) return countries;

    const exists = countries.some(
      (c) => c.name === internalValue || c.countryCode === internalValue
    );

    return exists ? countries : [{ name: internalValue, countryCode: "custom" }, ...countries];
  })();

  return (
    <FormControl fullWidth disabled={disabled}>
      <Select
        value={internalValue}
        onChange={handleChange}
        displayEmpty
        MenuProps={{
          MenuListProps: {
            className: "dataset-dropdown-list",
          },
          PaperProps: {
            className: "dataset-dropdown",
          },
        }}
      >
        {displayCountries.map((country) => (
          <MenuItem
            key={country.countryCode}
            value={country.name}
            className="dataset-dropdown-item"
          >
            {country.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DatasetDropdown;
